<main class="attendee-redirect-external__content container">
  <div class="attendee-redirect-external__content__section">
    <img
      class="attendee-redirect-external__container__image"
      src="./assets/checkout/confirmation/redirection.svg"
      alt="Code not found"
    />
    <div class="attendee-redirect-external__content__section__title">
      {{ redirectionTitle }}
    </div>
  </div>
</main>
